module.exports = __webpack_public_path__ + "media/images/brand/150/MARQUESBRANDINGCO LOGO ORIGINAL GOOGLE-28a49a18aba7688caf0ab313c566aca4.png";